import {
  Alignments,
  Directions,
  Flexbox,
  Modal,
  Sizes,
} from '@sede-enterprise/shell-ds-react-framework';
import {
  Action,
  Size,
} from '@sede-enterprise/shell-ds-react-framework/build/esm/react-base/src/components/Modal/Modal.types';
import { SyntheticEvent } from 'react';
import styled from 'styled-components';

const StyledModal = styled(Modal)`
  .shell-modal-container-content {
    overflow: visible !important;
  }
  .shell-modal-container-body {
    background-color: transparent;
  }
  .shell-modal-header {
    border-radius: 15px 15px 0px 0px;
    backgroud-color: white;
  }
  .shell-modal-footer {
    border-radius: 0px 0px 15px 15px;
    backgroud-color: white;
  }
`;

export const ShellModal: React.FC<{
  onClose: (event?: any) => void;
  open: boolean;
  actions: Action[];
  title?: string;
  showFooter: boolean;
  loading: boolean;
  children: React.ReactNode;
  closeButton?: boolean;
  size?: Size;
  scrollable?: boolean;
  minHeight?: number;
  maxHeight?: number;
  maxWidth?: number;
  minWidth?: number;
  headerDescription?: string;
  titleAdornment?: React.ReactNode;
  zIndex?: number;
}> = ({
  onClose,
  open,
  actions,
  title,
  showFooter,
  loading,
  children,
  size = Sizes.Medium,
  scrollable = false,
  minHeight,
  maxHeight,
  maxWidth,
  minWidth,
  headerDescription,
  titleAdornment,
  zIndex = 10,
}) => {
  const handleClose = (e?: SyntheticEvent<Element, Event>) => {
    // only close if button x clicked
    if (e && (e.target as HTMLElement).closest('button')) {
      onClose();
    }
  };

  return (
    <StyledModal
      {...(title
        ? {
            header: {
              title: (titleAdornment ? (
                <span
                  style={{
                    display: 'inline-flex',
                    alignItems: 'center',
                    gap: 8,
                  }}
                >
                  {title}
                  {titleAdornment}
                </span>
              ) : (
                title
              )) as unknown as string,
              description: headerDescription,
            },
            showHeader: true,
          }
        : { showHeader: false })}
      open={open}
      zIndex={zIndex}
      width="auto"
      height="auto"
      borders={true}
      centered
      size={size}
      closeButton={!!title}
      onClose={handleClose}
      actions={actions}
      actionsAlignment={Alignments.Right}
      actionsDirection={Directions.Horizontal}
      showFooter={showFooter}
      loading={loading}
      contentScrollable={scrollable}
      bodyStyle={{
        minHeight: minHeight,
        maxHeight: maxHeight,
        maxWidth: maxWidth,
        minWidth: minWidth,
      }}
      mask
    >
      <Flexbox
        flexDirection="column"
        rowGap="10px"
        style={{
          maxHeight: 700,
          maxWidth: '100%',
          zIndex: 20,
          overflowY: 'auto',
          padding: '4px',
        }}
      >
        {children}
      </Flexbox>
    </StyledModal>
  );
};
